var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[[_c('answer-sheet-list',{attrs:{"opt":_vm.answerSheetListOptions,"query-form":_vm.forms,"settle-type":1,"search-field":_vm.answerSheetListSearchFields}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }